import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPixabayComponent } from './simple-icons-pixabay.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPixabayComponent ],
    exports:      [ SimpleIconsPixabayComponent ],
    bootstrap:    []
})
export class SimpleIconsPixabayModule {}
